<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="comming_soon_popup"
      title="Maintenance en cours"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <div>
          <div class="modal-header-wrap text-center">
            <h3>En cours de maintenance</h3>
            <p class="text-muted">
              Ce module est en maintenance, veuillez réessayer ultérieurement.
            </p>
          </div>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "CommingSoonPop",
  mounted: async function () {},
  data: () => {
    return {};
  },
  methods: {},
};
</script>